export default __webpack_public_path__ + "locales/lo-LA/DataReassignmentDialog.json?hash=16a2167db63e1cb4dc71cddda7d8fbdc";